@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.business.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.business.resources/"

@delegate:ResourceContentHash(-409_252_534)
internal val Res.plurals.business_endorsements: PluralStringResource by lazy {
      PluralStringResource("plurals:business_endorsements", "business_endorsements", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 121),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("business_endorsements", Res.plurals.business_endorsements)
}
